module.exports = __webpack_public_path__ + "img/blankImage.5b41f2b8.jpg";